<template>
  <v-row class="k-progress-circular" justify="center" align="end">
    <v-col cols="12" class="label">
      <v-row>
        <v-col cols="12" sm="12" style="text-align: justify;">
          <slot></slot>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12" class="mt-2">
      <v-row justify="center">
        <v-col cols="12" class="progress  mt-4">
          <v-slider
            readonly
            :value="value"
            hide-details
            always-dirty
            persistent-hint
            thumb-label="always"
            height="20"
            color="info"
            track-color="grey lighten-1"
          >
            <template v-slot:thumb-label>
              <span> {{ value }}%</span>
            </template>
          </v-slider>
          <span class="s-color-grey font-weight-bold">{{ labeProgress }}</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'progress-circular',
  computed: {
    percentage() {
      return this.$props.value !== null ? `${this.$props.value}%` : 'Carregando'
    },
    teste() {
      return 50
    },
  },
  props: {
    value: {
      require: true,
      type: Number,
    },
    labeProgress: {
      require: false,
      type: String,
    },
  },
}
</script>

<style lang="scss">
.k-progress-circular {
  .progress {
    text-align: center;
  }
}
.v-slider__thumb-label__container {
  top: 10px;
}
.v-slider__thumb-label {
  border-radius: 50% 50% 50% !important;
}
.v-slider__thumb {
  display: none;
}
.v-slider__track-fill,
.v-slider__track,
.v-slider__track__container {
  height: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
